import React from 'react'
import { Button, Loader, Container } from 'swx-atomic-component-lib'

function ButtonWithSpinner ({
  onClick,
  value = 'Button',
  isLoading = false,
  disabled = false,
  customStyle = ''
}) {
  if (isLoading) {
    return (
      <Button
        customStyle={`${styles.buttonIconOnly} ${customStyle}`}
      >
        <Container width='16px'>
          <Loader
            type='spinner'
            duration={1}
            color='blue-light'
          />
        </Container>
      </Button>
    )
  }

  return (
    <Button
      onClick={onClick}
      customStyle={`${styles.button} ${customStyle}`}
      value={value}
      disabled={disabled}
    />
  )
}

const styles = {
  buttonIconOnly: `
    padding-left: 2.5em;
    padding-right: 2.5em;
    cursor: default;
    cursor: auto;
  `,

  button: `
    padding-left: 1.8em;
    padding-right: 1.8em;
  `,

  iconWrapper: `
    background-color: tomato;
    > div {
      background-color: black;
    }
  `
}

export default ButtonWithSpinner
